// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const flutter_mane: PokeData = {
  "id": 987,
  "name": "flutter-mane",
  "height": 14,
  "weight": 40,
  "base_experience": 285,
  "types": [
    PokeType.GHOST,
    PokeType.FAIRY
  ],
  "api_moves": [
    "psybeam",
    "confuse-ray",
    "spite",
    "perish-song",
    "mean-look",
    "pain-split",
    "shadow-ball",
    "memento",
    "wish",
    "astonish",
    "power-gem",
    "psyshock",
    "phantom-force",
    "moonblast",
    "mystical-fire",
    "dazzling-gleam"
  ],
  "moves": [
    "confuse-ray",
    "shadow-ball",
    "phantom-force",
    "moonblast",
    "dazzling-gleam",
    "shadow-claws",
    "shadow-sneak",
    "misty-terrain",
    "heal-bell",
    "spirit-break",
    "guardian-bond",
    "spectral-chain",
    "soul-sacrifice"
  ],
  "evolution_chain": {
    "id": 518,
    "item": null,
    "species": [
      {
        "name": "flutter-mane",
        "order": 983,
        "types": [
          PokeType.GHOST,
          PokeType.FAIRY
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 87,
    "speed": 157,
    "ability_power": 157
  },
  "stat_changes": [],
  "catch_rate": 30,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
